var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.readOnly ? 'pre' : 'b-form-textarea',{tag:"component",staticClass:"form-control form-control-sm",class:{'bg-gray-150 mb-0':_vm.readOnly},style:(_vm.style),attrs:{"type":"text"},model:{value:(_vm.valueFromProp),callback:function ($$v) {_vm.valueFromProp=$$v},expression:"valueFromProp"}},[_vm._v(_vm._s(_vm.valueFromProp))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f739fca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/framework/GtcTextarea.vue
// module id = null
// module chunks = 